import React from 'react';

import { Backdrop, CircularProgress } from '@mui/material';

const Circular: React.FC<{
  open: boolean;
}> = (props) => {
  const { open } = props;
  return (
    <>
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 2 }} open={open}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
};

export default Circular;
